$('[data-remote]').on('ajax:success', ({ target, detail: [data, error, xhr] }) => {
  if (xhr.getResponseHeader('Location')) {
    const $btn        = $(target.commit);
    const disableText = $btn.data('disableWith');

    setTimeout(() => {
      $btn.addClass('disabled');
      if (disableText) $btn.val(disableText)
    })

    location.href = xhr.getResponseHeader('Location');
  }
});



// WEBPACK FOOTER //
// app/javascript/common/remote-forms.js